"use strict";

Shopify.theme.jsProductShowcase = {
  init: function init($section) {
    // Selectors
    var _this = this;
    var $promoSlider = $section.find('[data-featured-promotions-slider]');
    var $categoryButton = $section.find(".featured-promotions__category");
    
    $categoryButton.on('click', function(){
      var category = $(this).attr("data-handle");
      console.log("change cat "+category);
      $categoryButton.removeClass("active");
      $(this).addClass("active");
      _this.changePromoCategory(category);
    });
  },
  changePromoCategory: function(category){
    $(".featured-promotions__block").removeClass("active");
    $(".featured-promotions__block."+category).addClass("active");    
  }
};

Shopify.theme.jsProductShowcase.init($(".product-showcase__wrapper"));